import UnassignEmployeeFromPropertyModal from "./UnassignEmployeeFromPropertyModalContainer";

export default UnassignEmployeeFromPropertyModal;
